import React from "react";
import YouLaberIDEShell from "./YouLaberIDEShell";

const YouLaberFullscreenOverlay = ({
  open,
  onClose,
  apiUrl,
  ccSelectedDevice,
  ccMessages,
  ccStreamingText,
  ccThinkingText,
  ccSessionState,
  ccStatus,
  ccInitInfo,
  ccPendingQuestion,
  ccTaskInfo,
  ccTokenUsage,
  ccFileTree,
  ccRoster,
  onSendMessage,
  onInterrupt,
  onQuestionRespond,
  onSendControl,
  onCompact,
  onClearHistory,
  onExportChatlog,
  onOpenArchive,
}) => {
  if (!open) return null;

  const deviceName = ccSelectedDevice?.device_name || "YouLabber 实验员";
  const isRunning = ccSessionState === "running";

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-label={`${deviceName} 实时对话`}
      style={{
        position: "fixed",
        top: "85px",
        left: "16px",
        right: "16px",
        bottom: "16px",
        zIndex: 420,
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        borderRadius: "14px",
        background: "#0a0d12",
        border: "1px solid rgba(88, 166, 255, 0.28)",
        boxShadow: "0 18px 60px rgba(0, 0, 0, 0.55)",
      }}
    >
      <div
        style={{
          flexShrink: 0,
          display: "flex",
          alignItems: "center",
          gap: "12px",
          padding: "10px 16px",
          minHeight: "48px",
          color: "#e6edf3",
          background: "linear-gradient(90deg, rgba(88,166,255,0.14), rgba(13,17,23,0.96))",
          borderBottom: "1px solid rgba(255,255,255,0.08)",
        }}
      >
        <span
          style={{
            width: "8px",
            height: "8px",
            borderRadius: "50%",
            background: isRunning ? "#3fb950" : "#8b949e",
            boxShadow: isRunning ? "0 0 0 4px rgba(63,185,80,0.16)" : "none",
            flexShrink: 0,
          }}
        />
        <div style={{ minWidth: 0, flex: 1 }}>
          <div style={{ fontSize: "14px", fontWeight: 700, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
            {deviceName}
          </div>
          <div style={{ marginTop: "2px", fontSize: "11px", color: "#8b949e" }}>
            综合训练 · YouLabber 实时工作区 · {isRunning ? "运行中" : "空闲"}
          </div>
        </div>
        {onOpenArchive && (
          <button
            type="button"
            onClick={onOpenArchive}
            style={{
              border: "1px solid rgba(88,166,255,0.32)",
              borderRadius: "8px",
              background: "rgba(88,166,255,0.08)",
              color: "#9cc9ff",
              padding: "6px 12px",
              fontSize: "12px",
              cursor: "pointer",
              fontFamily: "inherit",
            }}
          >
            查看实验记录
          </button>
        )}
        <button
          type="button"
          onClick={onClose}
          style={{
            border: "1px solid rgba(255,255,255,0.16)",
            borderRadius: "8px",
            background: "rgba(255,255,255,0.04)",
            color: "#c9d1d9",
            padding: "6px 12px",
            fontSize: "12px",
            cursor: "pointer",
            fontFamily: "inherit",
          }}
        >
          返回综合训练
        </button>
      </div>

      <YouLaberIDEShell
        apiUrl={apiUrl}
        ccSelectedDevice={ccSelectedDevice}
        ccMessages={ccMessages}
        ccStreamingText={ccStreamingText}
        ccThinkingText={ccThinkingText}
        ccSessionState={ccSessionState}
        ccStatus={ccStatus}
        ccInitInfo={ccInitInfo}
        ccPendingQuestion={ccPendingQuestion}
        ccTaskInfo={ccTaskInfo}
        ccTokenUsage={ccTokenUsage}
        ccFileTree={ccFileTree}
        ccRoster={ccRoster}
        onSendMessage={onSendMessage}
        onInterrupt={onInterrupt}
        onQuestionRespond={onQuestionRespond}
        onSendControl={onSendControl}
        onCompact={onCompact}
        onClearHistory={onClearHistory}
        onExportChatlog={onExportChatlog}
      />
    </div>
  );
};

export default YouLaberFullscreenOverlay;
